import React from 'react'
import { ExploreCourses } from './ExploreCourses'

export const CoursesHome = () => {
  return (
    <div>
        <ExploreCourses />
    </div>
  )
}
